import Vue from "vue";
import * as GmapVue from 'gmap-vue'
import GmapCluster from 'gmap-vue/dist/components/cluster' // replace dist with src if you have Babel issues

Vue.component('GmapCluster', GmapCluster)

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyACFZXTqraWwBXQZSlKj-QZhNUzIQ3OV0Y',
    libraries: 'places',
  },
  installComponents: true
});
